import { useExternalGroupFilesUrl } from '@ms/yammer-hooks/dist/urls';
import { groupAllFeedPage } from '@ms/yammer-web-support/dist/urls';
import React, { FC } from 'react';
import { Redirect } from 'react-router-dom';

export interface NonTeamsHubGroupFilesProps {
  readonly match: {
    readonly params: {
      readonly groupId: string;
    };
  };
}

const NonTeamsHubGroupFiles: FC<NonTeamsHubGroupFilesProps> = ({ match }) => {
  const { groupId } = match.params;
  const groupFilesUrl = useExternalGroupFilesUrl(groupId);

  window.open(groupFilesUrl, '_blank');

  return <Redirect to={groupAllFeedPage(groupId)} />;
};

export default NonTeamsHubGroupFiles;
